import * as $ from "jquery";

export default class FormControl {
  $domRoot: JQuery<HTMLElement>;
  params: any;
  paramKeys: { visibilityConditions: string; };
  $form: any;
  $control: any;
  
  constructor(domRoot: HTMLElement, params: any) {
    this.$domRoot = $(domRoot);
    this.params = { ...params };

    this.paramKeys = {
      visibilityConditions: "visibilityConditions",
    };

    this.init();
  }

  init() {
    "use strict";
    this.$form = this.$domRoot.closest("form");
    this.$control = this.$domRoot.find(":input").first();
    this.initVisibilityConditions();
  }

  initVisibilityConditions() {
    "use strict";
    var controlName = this.$control.attr("name");
    var visibilityConditions = {};
    var formVisibilityConditions;
    var newFormVisibilityConditions = {};

    if (
      controlName &&
      this.params.hasOwnProperty(this.paramKeys.visibilityConditions)
    ) {
      visibilityConditions[controlName] =
        this.params[this.paramKeys.visibilityConditions];
      formVisibilityConditions =
        this.$form.data(this.paramKeys.visibilityConditions) || {};
      newFormVisibilityConditions = Object.assign(
        {},
        formVisibilityConditions,
        visibilityConditions
      );

      this.$form.data(
        this.paramKeys.visibilityConditions,
        newFormVisibilityConditions
      );
    }
  }
}
